import React from 'react';
import { View, ViewStyle } from 'react-native';
import SelectBox from 'LocalGluons/components/SelectBox';
import { ITextTrack, IAudioTrack } from '@24i/player-base';
import { StyleMap } from 'types';
import Icon from '../../../Icon';

type MediaTrackSelectBoxStyles = {
    container?: ViewStyle;
    innerContainer?: ViewStyle;
    iconClose?: ViewStyle;
    backgroundContainer?: ViewStyle;
};

interface MediaTrackSelectBoxProps {
    defaultStyles: MediaTrackSelectBoxStyles;
    style: StyleMap;
    onSelectMediaTrack: (item: ITextTrack | IAudioTrack) => void;
    selectedMediaTracks: ITextTrack[] | IAudioTrack[];
    onClose: () => void;
    title: string;
}

const MediaTrackSelectBox = ({
    defaultStyles,
    style,
    onSelectMediaTrack,
    selectedMediaTracks,
    onClose,
    title
}: MediaTrackSelectBoxProps) => (
    <View style={[defaultStyles.container, style]}>
        <View style={defaultStyles.backgroundContainer} />
        <View style={defaultStyles.innerContainer}>
            <SelectBox
                heading={title}
                onSelect={onSelectMediaTrack}
                // TODO: Fix
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                items={selectedMediaTracks}
            />
        </View>
        <View style={defaultStyles.iconClose}>
            <Icon style={{ color: 'red' }} testID="close_button" name="close" onPress={onClose} />
        </View>
    </View>
);

export default MediaTrackSelectBox;
